import { AppState as RootState } from '../../store';
import { ValidationList, AvailableColumn, ValidationListColumn } from '@app/common/models';
import { ItemValueModel } from '@app/common/models/columnBase.model';
import { createFeatureSelector } from '@ngrx/store';

export interface ValidationEditorState
{
    validationLists: ValidationList[];
    validationListColumns: ValidationListColumn[];
    validationListselectedColumns: ValidationListColumn[];
    validationListselectedColumnsisLoading: boolean;
    availableColumns: AvailableColumn[];
    staticUsedlistValues: {[key: number]: ItemValueModel[]};
}

export interface AppState extends RootState {
    validationEditorState: ValidationEditorState;
}

export const InitialValidationEditorState = {
    validationLists: [],
    //obsolet ????
    validationListColumns: [],
    validationListselectedColumns: [],
    validationListselectedColumnsisLoading: false,
    availableColumns: [],
    staticUsedlistValues: {}
}

export const featureValidationEditorName = 'validationEditorState';

export const selectValidationEditorState = createFeatureSelector<ValidationEditorState>(featureValidationEditorName);
